/* eslint-disable react-hooks/exhaustive-deps */
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as wjCore from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
import * as wjrGrid from "@grapecity/wijmo.react.grid";
import dayjs from "dayjs";
import Decimal from "decimal.js";
import queryString from "query-string";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { AppDispatch } from "../../..";
import AlertComponent from "../../../components/AlertComponent";
import ComboBox from "../../../components/ComboBox";
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox";
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel";
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter";
import MonthInput from "../../../components/InputWrapper/MonthInput";
import Spinner from "../../../components/Spinner";
import CONST from "../../../constant";
import { 区分分類コード } from "../../../constant/enum/codes";
import { clearAlert, setAlerts } from "../../../globalStore/alertStore";
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore";
import SyaryoBetuUnkoSyusiService from "../../../service/budget/syaryoBetuUnkoSyusi/SyaryoBetuUnkoSyusiService";
import {
  TSyaryoBetuUnkoSyusiListReq,
  TSyaryoBetuUnkoSyusiListRes,
} from "../../../service/budget/syaryoBetuUnkoSyusi/TSyaryoBetuUnkoSyusi";
import BusyoService from "../../../service/master/busyo/busyoService";
import { 区分マスタ } from "../../../service/master/kubun/TKubun";
import KubunService from "../../../service/master/kubun/kubunService";
import NenryoTankaService from "../../../service/truckcontrol/nenryotanka/nenryoTankaService";
import gridPageHelper from "../../../ts/helpers/gridPageHelper";
import pageHelper from "../../../ts/helpers/pageHelper";
import { TWijmoComboBox } from "../../../type/wijmoComponents";

/**
 * 車輌別運行収支一覧
 * @returns
 */
const SyaryoBetuUnkoSyusiList = () => {
  const history = useHistory();
  const location = useLocation();

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SyaryoBetuUnkoSyusiList_GridId";

  // 燃料単価警告
  const [nenryoTankaWarning, setNenryoTankaWarning] = useState<string | null>(
    null,
  );
  // 検索月の燃料単価
  const [nenryoTanka, setNenryoTanka] = useState<number | null>(null);

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyaryoBetuUnkoSyusiListRes>,
    pageSize: number,
  ) =>
    new wjCore.CollectionView(
      [
        ...data.map((d) => ({
          ...d,
          運用粗利率: new Decimal(d.運用粗利率 ?? 0).div(100).toNumber(),
          運行収支差益率: new Decimal(d.運行収支差益率 ?? 0)
            .div(100)
            .toNumber(),
        })),
      ],
      {
        pageSize,
        // GridFooterからのイベント伝達用
        onPageChanged() {
          if (flexGrid && flexGrid.itemsSource) {
            const pageIndex = flexGrid!.itemsSource!.pageIndex;
            setPageNumber(pageIndex);
          }
        },
      },
    );

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyaryoBetuUnkoSyusiListReq) => {
    setIsSearching(true); // 検索中状態に遷移
    disPatch(clearAlert()); // アラートを非表示に

    let currentSearchCondition: TSyaryoBetuUnkoSyusiListReq;
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition;
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition();
    }

    if (currentSearchCondition == null) return;
    setPreSearchCondition({ ...currentSearchCondition });

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition);

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition),
    );

    try {
      const 検索年月 = dayjs(currentSearchCondition.年月);

      // 車輌別運行収支と燃料単価を並行取得
      const [res, tankaRes] = await Promise.all([
        new SyaryoBetuUnkoSyusiService().getList(currentSearchCondition),
        new NenryoTankaService().getList({
          検索年: 検索年月.format("YYYY/01/01"),
        }),
      ]);

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) });

      // 検索月の燃料単価を抽出
      const 検索月str = 検索年月.format("YYYY-MM");
      const tankaItem = tankaRes.data?.find(
        (d) =>
          dayjs(d.年月).format("YYYY-MM") === 検索月str && d.削除フラグ !== 1,
      );
      setNenryoTanka(tankaItem?.燃料単価 ?? 0);

      // 燃料単価未設定警告
      const w5002 = res.warns?.find((w) => w.code === "W5002");
      setNenryoTankaWarning(w5002 ? w5002.messageWithCode : null);
    } catch (error) {
      disPatch(setAlerts(error));
    } finally {
      setIsSearching(false); // 検索中状態に遷移
      flexGrid?.refresh();
    }
  };

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query = queryString.parse(
      location.search,
    ) as unknown as TSyaryoBetuUnkoSyusiListReq;
    set年月(query.年月);
    set部所ID(query.部所ID);

    部所ItemSource &&
      set部所コード(
        部所ItemSource.find((i) => i.部所ID === query.部所ID)?.部所コード,
      );
    return query;
  };

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyaryoBetuUnkoSyusiListReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所ID: 部所ID ?? undefined,
    };
  };

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyaryoBetuUnkoSyusiListReq,
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM");

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所ID === searchCondition.部所ID,
    );
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    };
  };

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem);
  };

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn()
        .binding as keyof TSyaryoBetuUnkoSyusiListRes;
      const targetRow = e.getRow();
      const dataItem: TSyaryoBetuUnkoSyusiListRes = targetRow.dataItem;

      // 原動機有無フラグ = 0 つまりトレーラ列は青色表示

      switch (cellBinding) {
        case "運用粗利益":
        case "運用粗利率":
        case "運行収支":
        case "運行収支差益率":
          if (dataItem[cellBinding] != null && dataItem[cellBinding] < 0) {
            wjCore.removeClass(e.cell, "text-trailer");
            wjCore.toggleClass(e.cell, "text-danger", true);
          } else {
            wjCore.toggleClass(
              e.cell,
              "text-trailer",
              dataItem.原動機有無フラグ !== 1,
            );
          }
          break;
        default:
          wjCore.toggleClass(
            e.cell,
            "text-trailer",
            dataItem.原動機有無フラグ !== 1,
          );
          break;
      }
    }
  };

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false);

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>();
  const [pageSize, setPageSize] = useState<number>(10);
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  });
  const [pageNumber, setPageNumber] = useState<number>(0);

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false); // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any;
  }>();

  //アラート制御
  const disPatch: AppDispatch = useDispatch();

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true);

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false);
  const [searchDataInitialized, setSearchDataInitialized] =
    useState<boolean>(false);

  //#endregion

  //#region [state]

  // デフォルトは前月
  const [年月, set年月] = useState<string | null | undefined>(
    dayjs().subtract(1, "month").toISOString(),
  );
  // const [区分ItemSource, set区分ItemSource] = useState<区分マスタ[]>()

  // combobox
  const [車輌別運行収支車種区分DataMap, set車輌別運行収支車種区分DataMap] =
    useState<wjcGrid.DataMap<区分マスタ>>();

  // 部所
  const [部所コード, set部所コード] = useState<string | null>();
  const [部所ID, set部所ID] = useState<number | null>();
  const [, set部所] = useState<T部所マスタ | null>();
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>();
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null);
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false);

  const [
    ,
    // preSearchCondition
    setPreSearchCondition,
  ] = useState<TSyaryoBetuUnkoSyusiListReq>();

  //#endregion

  //#region [effect]
  // APIからItemSourceを取得
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data);

      set車輌別運行収支車種区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.経営管理.月間車輌収支車種区分,
          ),
          "区分ID",
          "名称1",
        ),
      );

      setSearchDataInitialized(true);
    });
  }, []);

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && searchDataInitialized && 部所ComboBox) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse();

        // リストア中フラグON
        setIsRestoreSearching(true);

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除());
        });
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData();
        gridPageHelper.removeAllGridFilterAndSortStates();
        disPatch(画面ロック解除());
      }
    }
  }, [gridInitialized, searchDataInitialized, 部所ComboBox]);

  useEffect(() => {
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始());
  }, []);

  useEffect(() => {
    set部所ID(部所ItemSource?.find((i) => i.部所コード === 部所コード)?.部所ID);
  }, [部所コード]);

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車輌別運行収支一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
          {nenryoTankaWarning && (
            <Alert variant="warning" className="w-90rem">
              {nenryoTankaWarning.replace(
                "燃料単価登録画面から設定してください。",
                "",
              )}
              <Link to="/truckcontrol/nenryotanka/register">
                燃料単価登録画面
              </Link>
              から設定してください。
            </Alert>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}
            >
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div
                            className="search-condition-row"
                            style={{ alignItems: "center" }}
                          >
                            <div className="w-10rem">
                              <MonthInput
                                autoFocus
                                id="年月"
                                value={年月}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                              />
                            </div>
                            <ComboBox.Busyo
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}
                            />
                            <Button
                              type="submit"
                              disabled={isSearching}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.25rem",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                search();
                              }}
                            >
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                isShowGridRowPickupButton={true}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                hasFilter={true}
                headerComponent={
                  <div>
                    <span>※ データは 03:00 時点のものとなります。</span>
                    <span className="text-trailer ms-1">青はトレーラ車輌</span>
                    {nenryoTanka != null && nenryoTanka > 0 ? (
                      <span className="ms-3">燃料単価: {nenryoTanka}円/L</span>
                    ) : (
                      nenryoTanka != null && (
                        <span
                          className="ms-3"
                          style={{ color: "#ac171d", fontWeight: "bold" }}
                        >
                          燃料単価: 未設定
                        </span>
                      )
                    )}
                  </div>
                }
                gridProperties={{
                  frozenColumns: 4,
                }}
              >
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={180}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={72}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="担当乗務員コード"
                  header="管理乗務員"
                  width={108}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="登録番号"
                  width={180}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  dataMap={車輌別運行収支車種区分DataMap}
                  header="種別"
                  binding="月間車輌収支車種区分ID"
                  width={108}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="自部所売上"
                  header={"売上（自部所）"}
                  width={126}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="他部所売上"
                  header={"売上（他部所）"}
                  width={126}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="走行距離"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="稼働日数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="高速料"
                  header="高速代"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="燃料代"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="重自税"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車検代"
                  header="車検"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="三ヶ月点検代"
                  header="3ヶ月点検"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="その他修理"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="タイヤ費用"
                  header="タイヤ費"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="償却費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="任意保険"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="その他費用"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="運用粗利益"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運用粗利率"
                  format={"p2"}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="管理費"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="本社管理費"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="人件費"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="運行収支"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運行収支差益率"
                  format={"p2"}
                  width={126}
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="Km単価"
                ></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  format={"n0"}
                  binding="日車単価"
                ></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SyaryoBetuUnkoSyusiList;
